module.exports = __webpack_public_path__ + "img/8.eba3289c.jpg";